package system.network

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import component.*
import kotlinx.coroutines.channels.*
import models.*

class DeadReconSystem : IteratingSystem(family { all(PhysicSnapshotStateComponent, NetworkInputDataComponent) }) {

    private val serverSnapshots = Channel<PlayerPhysicStates>(capacity = 100)

    private var currentServerSnapshot: PlayerPhysicStates? = null

    fun addSnapshot(states: PlayerPhysicStates) {
        serverSnapshots.trySend(states)
    }

    override fun onTick() {
        currentServerSnapshot = serverSnapshots.tryReceive().getOrNull()

        if (currentServerSnapshot != null) {
            super.onTick()
        }
    }

    override fun onTickEntity(entity: Entity) {
        val serverSnapshot = currentServerSnapshot!!
        val snapshotComponent = entity[PhysicSnapshotStateComponent]
        val inputDataComponent = entity[NetworkInputDataComponent]

        println("inputdatacompt id : ${inputDataComponent.id}")
        println(serverSnapshot)
        val serverEntitySnapshot = serverSnapshot.states.firstOrNull { it.id == inputDataComponent.id } ?: return

        var counter = 0
        var currentClientSnapshot: StateSnapshot? = null

        for (clientSnapshot in snapshotComponent.snapshots) {
            if (clientSnapshot.sequence < serverSnapshot.sequence) {
                counter++
            } else {
                currentClientSnapshot = clientSnapshot
                break
            }
        }

        for (i in 0 until counter) {
            snapshotComponent.snapshots.dequeue()
        }

        if (currentClientSnapshot == null) {
            println("currentClientSnapshot is null")
            return
        }

        val physComp = entity[PhysicComponent]

        println("dead recon loaded")

        physComp.applyDelta = true
        physComp.posXd = serverEntitySnapshot.x // - currentClientSnapshot.physicState.x
        physComp.posYd = serverEntitySnapshot.y // - currentClientSnapshot.physicState.y
        physComp.vXd = serverEntitySnapshot.velocityX // - currentClientSnapshot.physicState.velocityX
        physComp.vYd = serverEntitySnapshot.velocityY // - currentClientSnapshot.physicState.velocityY
    }

}
